import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Can a grand piano be moved up stairs in London?',
      answer:
        'Yes, grand pianos can be moved up stairs in London by specialist piano movers. The process involves removing the legs and pedal lyre to reduce weight and dimensions, then carefully manoeuvring the piano body on a specialist piano board. For particularly challenging staircases with tight turns or limited headroom, external crane lifts may be required. Professional grand piano movers in London have the equipment and expertise to assess your specific staircase and determine the safest approach.',
    },
    {
      question: 'Does a grand piano need to be tuned after moving?',
      answer:
        'Yes, grand pianos typically require tuning 2-3 weeks after being moved. The moving process, changes in environment, and settling into a new location can affect the tension of the piano\'s strings. Professional piano movers recommend waiting this period to allow the instrument to acclimatise to its new environment before tuning. Many specialist grand piano removal companies in London can recommend experienced piano tuners or offer tuning services as part of their comprehensive moving package.',
    },
    {
      question: 'How long does a grand piano removal in London take?',
      answer:
        'A typical grand piano removal in London takes 3-5 hours for local moves within the same borough. This includes time for disassembling the legs and pedal lyre, protective wrapping, loading, transportation, unloading, and reassembly. More complex moves involving multiple flights of stairs, difficult access, or longer distances across London may take 5-8 hours. Concert grand piano removals generally require more time due to their size and weight. Your specialist will provide an accurate time estimate during the initial survey.',
    },
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-10 text-[#0e0d0b] text-center">
          Frequently Asked Questions — Grand Piano Removal London
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-[#d4d4ce] rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between bg-[#f5f5f0] hover:bg-[#e8e8e0] transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-[#0e0d0b] pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#c9a84c] transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 py-5 bg-white">
                  <p className="text-[#1a1916] leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}